module.exports = __webpack_public_path__ + "img/03-2-2业务发展.66f0fa56.svg";